// extracted by mini-css-extract-plugin
export default {"container":"reports_container__B1w7m"};